export const CREATE_CONTACT_REQUEST_COMPANY_NAME_MAX_LENGTH = 200;
export function withOptionalCompanyIdentity(payload, company) {
    if (!company) {
        return payload;
    }
    const companyDocument = normalizeCompanyDocument(company.document);
    const companyName = optionalCompanyName(company.name);
    return {
        ...payload,
        ...(companyDocument === undefined ? {} : { companyDocument }),
        ...(companyName === undefined ? {} : { companyName }),
    };
}
function normalizeCompanyDocument(value) {
    if (typeof value !== 'string') {
        return undefined;
    }
    const normalized = value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    return normalized.length === 0 ? undefined : normalized;
}
function optionalCompanyName(value) {
    if (typeof value !== 'string') {
        return undefined;
    }
    const trimmed = value.trim();
    if (trimmed.length === 0) {
        return undefined;
    }
    return trimmed.length > CREATE_CONTACT_REQUEST_COMPANY_NAME_MAX_LENGTH
        ? trimmed.slice(0, CREATE_CONTACT_REQUEST_COMPANY_NAME_MAX_LENGTH)
        : trimmed;
}
